"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "user"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Achievements/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Header_Learner_template = require("../../components/Header-Learner.marko"),
    Header_Learner_tag = marko_loadTag(Header_Learner_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    IssuedCertificate_template = require("../../components/IssuedCertificate.marko"),
    IssuedCertificate_tag = marko_loadTag(IssuedCertificate_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "font-medium-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("1a31f7"),
    marko_node0 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("img", {
        src: "/images/illustration/achievement.webp",
        alt: "illustration",
        "class": "w-75"
      }, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "content-body pb-4"
      },
    marko_attrs2 = {
        "class": "mt-2"
      },
    marko_attrs3 = {
        "class": "font-medium-2 px-1"
      };

function render(input, out, __component, component, state) {
  var data = input;

  const Certificates = state.user && state.user.learner && state.user.learner.certificates || []

  Wrapper_tag({
      class: "pl-5 pr-3",
      scroll: true,
      renderBody: function(out) {
        if (Certificates == null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!Certificates.length) {
          Header_Learner_tag({
              intro: "Good day",
              concern: state.user.first_name + "!",
              assessment: {
                  icon: "bx bxs-smile",
                  subject: "No achievement on your belt yet"
                },
              ranking: {}
            }, out, __component, "2");

          Row_tag({
              class: "d-flex align-items-center",
              col: [
                  {
                      class: "col text-center",
                      renderBody: function(out) {
                        out.be("h3", null, "5", component);

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("Happy Achievements");
                            }
                          }, out, __component, "6");

                        out.ee();

                        out.be("p", marko_attrs0, "7", component);

                        Locale_tag({
                            renderBody: function(out) {
                              out.t("You have no achievement record yet");
                            }
                          }, out, __component, "8");

                        out.ee();

                        out.n(marko_node0, component);

                        out.n(marko_node1, component);

                        route_link_tag({
                            href: "/explore",
                            class: "btn btn-primary btn-lg px-4",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Start with a course"
                                }, out, __component, "12");
                            }
                          }, out, __component, "11");
                      }
                    },
                  {
                      class: "col w-100 text-center",
                      renderBody: function(out) {
                        out.n(marko_node2, component);
                      }
                    }
                ]
            }, out, __component, "3");
        } else {
          Header_Learner_tag({
              intro: "Good day",
              concern: state.user.first_name + "!",
              assessment: {
                  icon: "bx bxs-smile",
                  subject: "How many live sessions have you had this week?"
                },
              ranking: {}
            }, out, __component, "15");

          out.be("div", marko_attrs1, "16", component);

          out.be("section", marko_attrs2, "17", component);

          out.be("h5", marko_attrs3, "18", component);

          Locale_tag({
              text: "Certificates"
            }, out, __component, "19");

          out.ee();

          Row_tag({
              class: "no-gutters",
              renderBody: function(out) {
                var $for$0 = 0;

                marko_forOf(Certificates, function(certificate, index) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  WSAdapt_tag({
                      ns: "col-lg-2 col-md-3 col-6",
                      hs: "col-6",
                      qs: "col-lg-3 col-md-4 col-6",
                      renderBody: function(out) {
                        IssuedCertificate_tag({
                            certificate: certificate,
                            actions: [
                                "view"
                              ]
                          }, out, __component, "21" + $keyScope$0);
                      }
                    }, out, __component, index);
                });
              }
            }, out, __component, "20");

          out.ee();

          out.ee();
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
